<template>
  <div style="background-color: white; text-align: center; padding-top: 3.5vh; padding-bottom: 6.5vh;">
    <hr>
    <div class="px-4">
      <!-- <p style="padding-top: 3vh;">Gold Coast Nannies -- Chicago, IL 60610 -- 773 707 6818 -- sarah@goldcoastnannies.company</p> -->
      <!-- <img class="mt-3" src="../../assets/img/general/testimonialsflowers_trim.png" alt=""> -->
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      email: '',
      emailEmployer: '',
      emailCandidate: '',
      justSubscribed: false,
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/Footer.vue